import React from 'react';

const MediaHeader = (props) => {
  return (
    <div className="HeaderMedia">
    	<img src={props.image} alt=""/>
    </div>
  )
}

export default MediaHeader;


// WEBPACK FOOTER //
// ./src/components/header-media.js